// extracted by mini-css-extract-plugin
export var label = "_da-1";
export var reminder = "_da-0";